import { xcss, Box, Text } from '@atlaskit/primitives';
import { FormattedMessage } from 'react-intl';
import { useInfo, useToken } from '../../../../../Flow/ConsentContextProvider';
import { getForgeMcpAppName } from '#definitions/consent-info';
import { headlineMessages } from '../messages';

const headlineTextStyles = xcss({
  margin: 'space.0',
  font: 'font.heading.large',
  color: 'color.text',
});

interface HeaderProps {
  product?: string;
  agentName?: string;
  agentDescription?: string;
}

/** The headline names the agent, then the Forge app, else the product. */
function getTitleMessage(agentName?: string, forgeAppName?: string) {
  if (agentName) return headlineMessages.agentTitle;
  if (forgeAppName) return headlineMessages.forgeAppTitle;
  return headlineMessages.title;
}

const Header = ({
  product = 'Atlassian',
  agentName,
  agentDescription,
}: HeaderProps) => {
  const { clientName } = useToken();
  const info = useInfo();
  const forgeAppName = getForgeMcpAppName(info);

  return (
    <>
      <Box as="h1" xcss={headlineTextStyles}>
        <FormattedMessage
          {...getTitleMessage(agentName, forgeAppName)}
          values={{
            requestingParty: clientName,
            product,
            appName: forgeAppName,
            agentName,
          }}
        />
      </Box>
      {agentName && agentDescription ? (
        <Text as="p">{agentDescription}</Text>
      ) : null}
    </>
  );
};

export default Header;
